module.exports = __webpack_public_path__ + "img/options3_2.2dd4cde9.png";